export { default } from './ScoredTableHeader'
